import React, { createContext, useContext, useState, useEffect } from "react";

// Lets a page with local unsaved-changes state (currently: the scene edit
// page) be "asked" by something outside itself — the sidebar nav — before a
// click navigates away. The page registers { hasUnsavedChanges, requestLeave }
// while mounted; requestLeave is the same function the page uses for its own
// Back button / breadcrumb, so the sidebar reuses the page's own confirmation
// modal instead of every consumer needing its own copy.
const UnsavedChangesContext = createContext({ guard: null, setGuard: () => {} });

export function UnsavedChangesProvider({ children }) {
  const [guard, setGuard] = useState(null);
  return (
    <UnsavedChangesContext.Provider value={{ guard, setGuard }}>
      {children}
    </UnsavedChangesContext.Provider>
  );
}

// Called by a page that has something to protect.
export function useRegisterUnsavedChangesGuard(hasUnsavedChanges, requestLeave) {
  const { setGuard } = useContext(UnsavedChangesContext);
  useEffect(() => {
    setGuard({ hasUnsavedChanges, requestLeave });
    return () => setGuard(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasUnsavedChanges, requestLeave]);
}

// Called by anything that navigates the user away (e.g. the sidebar) and
// wants to check first. Returns null when no page currently has a guard.
export function useUnsavedChangesGuard() {
  return useContext(UnsavedChangesContext).guard;
}
